import {triggerAppChange} from 'single-spa';
import store from '../../store.js';
import {getAuthToken, getUsers} from '../../dux/auth';

const unsubscribe = store.subscribe(() => {
  triggerAppChange();
});
store.dispatch(getAuthToken());
store.dispatch(getUsers());

export const getAuthContext = () => {
  const {auth: {isAuthenticating=true, isLoggedIn=false, authToken, user: {effectiveAccesses: accesses={}}={}, enterprisePlan: {data: enterprisePlan}={}}={}} = store.getState();
  return {isAuthenticating, isLoggedIn, authToken, accesses, enterprisePlan};
}
export const persistCurrentAuthToken = () => {
  const {authToken} = getAuthContext();
  localStorage.setItem('auth.persistedAuthToken', authToken);
}
export const isLoggedIn = () => {
  const {isAuthenticating, isLoggedIn} = getAuthContext();
  return isLoggedIn && !isAuthenticating;
}
export const isLoggedOut = () => {
  const {isAuthenticating, isLoggedIn} = getAuthContext();
  return !isLoggedIn && !isAuthenticating;
}
export const hasAccess = (access, accessLevel) => () => {
  const {accesses} = getAuthContext();
  const hasAccess = accesses && accesses[access] && accesses[access].levels && accesses[access].levels.length>0 && accesses[access].levels.indexOf('Never')<0 && (!accessLevel || accesses[access].levels.indexOf('Always')>-1 || accesses[access].levels.indexOf(accessLevel)>-1);
  return !!hasAccess;
}
export const hasAccesses = (accesses=[]) => () => {
  return accesses.map(access => hasAccess(access)()).reduce((final, curr) => final && curr, true);
}
export const hasEnterprisePlan = (requiredPlan) => () => {
  const {enterprisePlan={}} = getAuthContext(); 
  const hasEnterprisePlan = (enterprisePlan && enterprisePlan[requiredPlan] && enterprisePlan[requiredPlan].isActive) || (!enterprisePlan.isActive && !requiredPlan);
  return !!hasEnterprisePlan;
}
export const hasEnterprisePlans = (requiredPlans=[]) => () => {
  return requiredPlans.map(requiredPlan => hasEnterprisePlan(requiredPlan)()).reduce((final, curr) => final && curr, true);
}
